import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import MyOrders from './MyOrders.jsx';
import { Context } from './StockManagerContext.jsx';
import { createOrdersUnderUserAccount } from '../private/permissions.js';

export default function MyOrdersButton() {
    const [ openModal, setOpenModal ] = useState(_ => _);
    const { currentUser } = useContext(Context);

    const showButton = currentUser && createOrdersUnderUserAccount(currentUser.userRole);

    return showButton ? (
        <>
            <a className={`btn my-orders`} onClick={openModal} style={{ cursor: 'pointer' }}>
                My Orders
            </a>
            <MyOrdersModal getMethods={methods => {
                setOpenModal(() => methods.open);
            }} />
        </>
    ) : null;
}

function MyOrdersModal({ getMethods }) {

    const [ show, setShow ] = useState(false);

    useEffect(() => {
        getMethods({
            open: () => {
              setShow(true);
            }
        });
    }, []);

    const close = () => {
      setShow(false);
    };

    return (
      <>
        <Modal show={show} onHide={close} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>My Orders</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '80vh', overflow: 'auto' }}>
            <MyOrders />
          </Modal.Body>
        </Modal>
      </>
    );
};